import React, {Component} from 'react';
import AppNavigation from '../AppNavigation';
import AppFooter from '../AppFooter';
import SubTopCandidates from '../Subcomponents/TopCandidates';
import withRouter from '../Functions/WithRouter';

class OrgTopCandidates extends Component {
    constructor(props) {
      super(props)

      this.state = {
      }
    }

    componentDidMount(){
      document.body.style.backgroundColor = "rgba(178,186,191,0.2)";

      const { org } = this.props.params

      let email = localStorage.getItem('email');
      let roleName = localStorage.getItem('roleName');
      let activeOrg = localStorage.getItem('activeOrg');
      let username = localStorage.getItem('username');
      let cuFirstName = localStorage.getItem('firstName');
      let cuLastName = localStorage.getItem('lastName');
      const orgLogo = localStorage.getItem('orgLogo');

      let selectedJob = null
      let applications = null
      let selectedBenchmark = null
      if (this.props.location && this.props.location.state) {
        selectedJob = this.props.location.state.selectedJob
        applications = this.props.location.state.applications
        selectedBenchmark = this.props.location.state.selectedBenchmark
      }
      // console.log('in topApps', this.props.location.state)
      this.setState({ emailId: email, username, cuFirstName, cuLastName, org,
        selectedJob, applications, selectedBenchmark, orgLogo
      })
    }

    render() {

      return (
          <div>
              <AppNavigation fromOrganization={true} org={this.state.org} history={this.props.navigate} />

              <SubTopCandidates history={this.props.navigate} org={this.state.org} selectedJob={this.state.selectedJob} applications={this.state.applications} selectedBenchmark={this.state.selectedBenchmark} />

              {(this.state.org) && (
                <div>
                  {AppFooter(this.props.navigate,this.state.org,this.state.orgLogo)}
                </div>
              )}
          </div>
      )
    }
}

export default withRouter(OrgTopCandidates)
